const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const getWs02Token = require('@dbk-legacy/wso2token').getToken;
const getIPaddress = require('@dbk-legacy/wso2token').getIPaddress;
const { Base64 } = require('js-base64');
const { decode } = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler,
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {

    getGlobalAuthEncryptionKey(userId, type, metaData) {
      const url = getUrl('getEncryptionToken');
      var seskey = '';
      if (type != 'login') {
        const parsedMetaData = parseRequestMetaData(metaData);
        seskey = parsedMetaData.info.sessionId;
      }

      const body = {
        userId,
        type: type,
        seskey: seskey
      };

      const reqOpts = {
        headers: merge(headers, {
          Authorization: getWs02Token(),
          'X-CLIENT-IP': getIPaddress(),
        }),
        method: 'POST'
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }
      ));
    },

    getGlobalAuthEncryptionKeyForLUX(inputParam, metaData) {
      const url = getUrl('getEncryptionToken');
      const params = inputParam.split('#@#');
      var seskey = '';
      if (params[2] != 'login') {
        const parsedMetaData = parseRequestMetaData(metaData);
        seskey = parsedMetaData.info.sessionId;
      }

      const body = {
        userId: Base64.decode(params[0]),
        type: params[2],
        seskey: params[1]
      };

      const reqOpts = {
        headers: merge(headers, {
          Authorization: getWs02Token(),
          'X-CLIENT-IP': getIPaddress(),
        }),
        method: 'POST'
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }
      ));
    },

    getGlobalAuthentication(userId, password, dummySesKey, token, cryptoPass, deviceInfo, regionCode) {
      const url = getUrl('authenticate');
      const ergonPw = cryptoPass.replace(/\*/g, '.');
      const body = {
        userId,
        password: password,
        seskey: dummySesKey,
        e2ePassword: regionCode == 'CH' ? ergonPw : cryptoPass,
        token: token,
        channel: deviceInfo != undefined ? deviceInfo : '',
      };
      const reqOpts = {
        headers: merge(headers, {
          Authorization: getWs02Token(),
          'X-CLIENT-IP': getIPaddress(),
        }),
        method: 'POST'
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    },

    getGlobalAuthenticationForLUX(inputParam, metaData) {
      const url = getUrl('authenticate');

      const params = inputParam.split('#@#');
      const ergonPw = params[4].replace(/\*/g, '.');

      const body = {
        userId: Base64.decode(params[0]),
        password: params[1],
        seskey: params[2],
        e2ePassword: params[6] == 'CH' ? ergonPw : params[4],
        token: params[3],
        channel: params[5] != undefined ? params[5] : '',
      };

      const reqOpts = {
        headers: merge(headers, {
          Authorization: getWs02Token(),
          'X-CLIENT-IP': getIPaddress(),
        }),
        method: 'POST'
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    },


    globalAuthChangeProfilePassword(userId, encryptedPassword, oldEncryptedPassword, oldCryptoPassword, newCryptoPassword, token, dummySesKey, regionCode, metaData) {
      const url = getUrl('changeProfilePassword');
      const jwe = token.replace(/\*/g, '.');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
        userId: userId,
        oldPboPassword: oldEncryptedPassword,
        newPboPassword: encryptedPassword,
        token: regionCode == 'CH' ? jwe : token,
        oldDbPassword: oldCryptoPassword,
        newDbPassword: newCryptoPassword,
        seskey: regionCode == 'CH' ? dummySesKey : parsedMetaData.info.sessionId,
        language: regionCode == 'CH' ? ' ' : parsedMetaData.portfolio.language
      }



      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    },

    globalAuthChangeProfilePasswordForLux(userId, encryptedPassword, oldEncryptedPassword, oldCryptoPassword, newCryptoPassword, token, dummySesKey, regionCode, metaData) {
      const url = getUrl('changeProfilePassword');
      const jwe = token.replace(/\*/g, '.');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
        userId: Base64.decode(userId),
        oldPboPassword: oldEncryptedPassword,
        newPboPassword: encryptedPassword,
        token: regionCode == 'CH' ? jwe : token,
        oldDbPassword: oldCryptoPassword,
        newDbPassword: newCryptoPassword,
        seskey: regionCode == 'CH' ? dummySesKey : parsedMetaData.info.sessionId,
        language: regionCode == 'CH' ? ' ' : parsedMetaData.portfolio.language
      }



      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    },

    initiateResetPin(inputParam, metaData) {
      const url = getUrl('initiateResetPin');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = JSON.parse(Base64.decode(inputParam));
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    generateAuthCodeForECred(inputParam, metaData) {
      const url = getUrl('generateAuthCodeForECred');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = JSON.parse(Base64.decode(inputParam));
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    validateECredAuthCode(inputParam, metaData) {
      const url = getUrl('validateECredAuthCode');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = JSON.parse(Base64.decode(inputParam));
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    updateECredStatus(inputParam, metaData) {
      const url = getUrl('updateECredStatus');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = JSON.parse(Base64.decode(inputParam));
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    initiateResetPassword(inputParam, metaData) {
      const url = getUrl('initiateResetPassword');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = JSON.parse(Base64.decode(inputParam));
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    generateTempPassword(inputParam, metaData) {
      const url = getUrl('generateTempPassword');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
        json: true
      };
      const body = JSON.parse(Base64.decode(inputParam));
      return requestHandler(merge(
        {},
        reqOpts, { url, body }
      ));
    },

    logout(metaData, channelInfo, logoutDsc) {
      const url = getUrl('dwologout');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
        userId: parsedMetaData.qs.userId,
        channel: channelInfo,
        logoutDesc: decode(logoutDsc)
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true
      }));
    },

    updatePassword(inputParam, metaData) {
      const url = getUrl('updatePassword');
      const parsedMetaData = parseRequestMetaData(metaData);
      const { userId, seskey, e2eOldPassword, e2eNewPassword, token, channel, changePasswordType } = JSON.parse(Base64.decode(inputParam));
      
      const oldPwd = e2eOldPassword.replace(/\*/g, '.');
      const newPwd = e2eNewPassword.replace(/\*/g, '.');

      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
      };
      
      const body = {
        userId,
        seskey,
        e2eOldPassword: oldPwd,
        e2eNewPassword: newPwd,
        token,
        channel,
        changePasswordType
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    },

    initiateChangePassword(inputParam, metaData) {
      const url = getUrl('initiateChangePassword');
      const parsedMetaData = parseRequestMetaData(metaData);
      const { userId, seskey, channel } = JSON.parse(Base64.decode(inputParam));
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST',
      };
      const body = {
        userId,
        seskey,
        channel
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
        mergeCookies: true
      }));
    }
  };
}

module.exports = apiFactory;
